<template>
  <!-- Need to use vshow as we are using a form field -->
  <div v-show="showPaymentInfo || editPaymentInfo">
    <TextField
      id="freedompay-store-id"
      :name="fieldName"
      :label="translate(`${LOCALE_PREFIX}.form.freedomPayStoreId`)"
      :placeholder="translate(`${LOCALE_PREFIX}.form.freedomPayStoreIdPlaceholder`)"
      :required="editPaymentInfo"
      :disabled="!editPaymentInfo"
    />
  </div>

  <div v-show="!showPaymentInfo && !editPaymentInfo">
    <Password
      id="freedompay-store-id"
      v-model="dummyValue"
      :placeholder="translate(`${LOCALE_PREFIX}.form.freedomPayStoreIdPlaceholder`)"
      :disabled="true"
      :required="editPaymentInfo"
    >
      <template #label>
        {{ translate(`${LOCALE_PREFIX}.form.freedomPayStoreId`) }}
      </template>
    </Password>
  </div>
</template>

<script setup lang="ts">
import { TextField } from '@centric-os/components/src/composed/validators/text-field';
import { Password } from '@centric-os/components/src/core/controls/password';
import { useTranslation } from '@centric-os/helpers';
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../../enums';
import { useFinancialConfigStore, usePaymentInfoStore } from '../../../../../../../routes';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_PAYMENT_INFO;

// Dummy ref
const dummyValue = ref<string>('*******');

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editPaymentInfo, isStationInitialSetup } = storeToRefs(fConfigStore);

// Set payment info store
const paymentInfoStore = usePaymentInfoStore();
const { showPaymentInfo } = storeToRefs(paymentInfoStore);

const fieldName = computed<string>(() => {
  if (isStationInitialSetup.value) {
    return 'paymentConfig.paymentSettings.freedompay.freedompay_store_id';
  }
  return 'freedompay.freedompay_store_id';
});
</script>
